module.exports = __webpack_public_path__ + "blackscentsticks.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackscentsticks.png
// module id = 868
// module chunks = 0